<template>
  <div>
    <v-dialog v-model="interno" persistent max-width="1200" scrollable>
      <v-card>
        <v-card-title class="subtitle-1">
          KPI Roles — Contabilización de clases
          <v-spacer />
          <v-btn icon @click="cerrar"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          <v-row dense>
            <v-col cols="12" md="3">
              <v-select
                v-model="escuela"
                :items="escuelas"
                label="Escuela"
                filled
                dense
                hide-details
                item-text="text"
                item-value="value"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="periodo"
                :items="periodos"
                label="Periodo"
                filled
                dense
                hide-details
                item-text="text"
                item-value="value"
              />
            </v-col>
            <v-col cols="12" md="5" class="d-flex align-center" style="gap: 8px">
              <v-btn small tile color="primary" dark :loading="cargando" @click="cargar">
                <v-icon left small>mdi-refresh</v-icon>
                Consultar
              </v-btn>
              <v-btn small tile color="indigo" dark @click="dialogCambios = true" :disabled="!resumen">
                <v-icon left small>mdi-swap-horizontal</v-icon>
                Cambios
              </v-btn>
              <v-btn small tile color="error" dark @click="abrirSinTeacher" :disabled="!idCiclo">
                <v-icon left small>mdi-account-cancel</v-icon>
                Sin teacher
              </v-btn>
              <v-btn small tile color="green" dark @click="exportarExcel" :disabled="!filas.length">
                <v-icon left small>mdi-microsoft-excel</v-icon>
                Excel
              </v-btn>
            </v-col>
          </v-row>

          <v-alert v-if="avisoTabla" dense colored-border border="left" type="warning" class="mt-3 mb-0">
            {{ avisoTabla }}
          </v-alert>

          <v-row class="mt-3" dense>
            <v-col cols="12" md="4" v-for="card in cardsGlobales" :key="card.key">
              <v-card
                outlined
                class="pa-3 card-kpi"
                :class="{ 'card-kpi--activa': cardActiva === card.key }"
                @click="toggleCard(card.key)"
              >
                <div class="text-caption grey--text">{{ card.title }}</div>
                <div class="text-h6">{{ card.clases }} clases</div>
                <div class="text-body-2">{{ card.cambios }} cambios ({{ card.pct }}%)</div>
                <div class="text-caption">Permiso/Falta: {{ card.pctPF }}%</div>
              </v-card>
            </v-col>
          </v-row>

          <div v-if="modoDetalle" class="text-caption primary--text mt-3 mb-0">
            Vista detalle: {{ tituloCardActiva }} (clic de nuevo en la tarjeta para volver al general)
          </div>

          <v-data-table
            class="mt-4 elevation-0 tabla-kpi-totales"
            dense
            :headers="headersActivos"
            :items="filas"
            :loading="cargando"
            :items-per-page="25"
            :item-key="modoDetalle ? 'key' : 'id_plantel'"
          >
            <template v-slot:item.escuela="{ item }">
              {{ Number(item.escuela) === 2 ? 'FAST' : 'INBI' }}
            </template>
            <template v-slot:item.escuela_nombre="{ item }">
              {{ item.escuela_nombre || (Number(item.escuela) === 2 ? 'FAST' : 'INBI') }}
            </template>
            <template v-slot:item.porcentaje_cambios="{ item }">
              {{ item.porcentaje_cambios }}%
            </template>
            <template v-slot:item.porcentaje_permiso_falta="{ item }">
              {{ item.porcentaje_permiso_falta }}%
            </template>

            <!-- Totales al final (vista general y vista detalle de tarjetas) -->
            <template v-slot:body.append>
              <tr v-if="filas.length" class="fila-totales">
                <template v-if="modoDetalle">
                  <td><strong>TOTAL</strong></td>
                  <td class="text-caption">{{ tituloCardActiva || 'Todas' }}</td>
                  <td><strong>{{ totales.total_clases }}</strong></td>
                  <td><strong>{{ totales.cambios_lunes }}</strong></td>
                  <td><strong>{{ totales.cambios_martes }}</strong></td>
                  <td><strong>{{ totales.cambios_miercoles }}</strong></td>
                  <td><strong>{{ totales.cambios_jueves }}</strong></td>
                  <td><strong>{{ totales.cambios_viernes }}</strong></td>
                  <td><strong>{{ totales.total_cambios }}</strong></td>
                  <td><strong>{{ totales.porcentaje_cambios }}%</strong></td>
                </template>
                <template v-else>
                  <td><strong>TOTAL</strong></td>
                  <td>—</td>
                  <td><strong>{{ totales.total_clases }}</strong></td>
                  <td><strong>{{ totales.total_cambios }}</strong></td>
                  <td><strong>{{ totales.porcentaje_cambios }}%</strong></td>
                  <td><strong>{{ totales.cambios_permiso }}</strong></td>
                  <td><strong>{{ totales.cambios_falta }}</strong></td>
                  <td><strong>{{ totales.porcentaje_permiso_falta }}%</strong></td>
                </template>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Submodal: cambios realizados -->
    <v-dialog v-model="dialogCambios" persistent max-width="1100" scrollable>
      <v-card>
        <v-card-title class="subtitle-1">
          Cambios realizados — anotar situación
          <v-spacer />
          <v-btn icon @click="dialogCambios = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-btn small tile color="primary" class="mb-3" dark :loading="cargandoCambios" @click="cargarCambios">
            <v-icon left small>mdi-refresh</v-icon>
            Actualizar lista
          </v-btn>
          <v-data-table
            dense
            :headers="headersCambios"
            :items="cambios"
            :loading="cargandoCambios"
            :items-per-page="15"
          >
            <template v-slot:item.motivo="{ item }">
              {{ labelMotivo(item.motivo) }}
            </template>
            <template v-slot:item.situacion="{ item }">
              <v-edit-dialog
                :return-value.sync="item.situacion"
                large
                save-text="Guardar"
                cancel-text="Cancelar"
                @save="guardarSituacion(item)"
              >
                <span>{{ item.situacion || 'Click para anotar' }}</span>
                <template v-slot:input>
                  <v-textarea v-model="item.situacion" label="Situación del cambio" rows="3" />
                </template>
              </v-edit-dialog>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Submodal: sin teacher -->
    <v-dialog v-model="dialogSinTeacher" persistent max-width="1000" scrollable>
      <v-card>
        <v-card-title class="subtitle-1">
          Clases sin teacher (no se dio / sin asignar)
          <v-spacer />
          <v-btn icon @click="dialogSinTeacher = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-data-table
            dense
            :headers="headersSinTeacher"
            :items="sinTeacher"
            :loading="cargandoSinTeacher"
            :items-per-page="20"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx'

export default {
  name: 'DialogKpiRoles',
  props: {
    value: { type: Boolean, default: false },
    ciclo: { type: Object, default: null },
  },
  data: () => ({
    escuela: 0,
    /** null = general; 'inbi' | 'fast' | 'ambas' = vista detalle */
    cardActiva: null,
    periodo: 5,
    escuelas: [
      { text: 'Ambas escuelas', value: 0 },
      { text: 'INBI', value: 1 },
      { text: 'FAST', value: 2 },
    ],
    periodos: [
      { text: 'P1 — Semana 1', value: 1 },
      { text: 'P2 — Semana 2', value: 2 },
      { text: 'P3 — Semana 3', value: 3 },
      { text: 'P4 — Semana 4', value: 4 },
      { text: 'P5 — Conjunto de todas las semanas', value: 5 },
    ],
    cargando: false,
    resumen: null,
    avisoTabla: '',
    dialogCambios: false,
    dialogSinTeacher: false,
    cambios: [],
    cargandoCambios: false,
    sinTeacher: [],
    cargandoSinTeacher: false,
    /** Vista general (por defecto) */
    headersGeneral: [
      { text: 'Sucursal', value: 'plantel' },
      { text: 'Escuela', value: 'escuela' },
      { text: 'Clases', value: 'total_clases' },
      { text: 'Cambios', value: 'total_cambios' },
      { text: '% Cambios', value: 'porcentaje_cambios' },
      { text: 'Permiso', value: 'cambios_permiso' },
      { text: 'Falta', value: 'cambios_falta' },
      { text: '% Permiso/Falta', value: 'porcentaje_permiso_falta' },
    ],
    /** Vista al activar tarjeta: escuela, días, clases, % */
    headersDetalle: [
      { text: 'Sucursal', value: 'plantel' },
      { text: 'Escuela', value: 'escuela_nombre' },
      { text: 'Clases', value: 'total_clases' },
      { text: 'Lunes', value: 'cambios_lunes' },
      { text: 'Martes', value: 'cambios_martes' },
      { text: 'Miércoles', value: 'cambios_miercoles' },
      { text: 'Jueves', value: 'cambios_jueves' },
      { text: 'Viernes', value: 'cambios_viernes' },
      { text: 'Total cambios', value: 'total_cambios' },
      { text: '% Cambios', value: 'porcentaje_cambios' },
    ],
    headersCambios: [
      { text: 'Fecha', value: 'fecha_registro' },
      { text: 'Sucursal', value: 'plantel' },
      { text: 'Grupo', value: 'grupo' },
      { text: 'Semana', value: 'semana' },
      { text: 'Bloque', value: 'bloque' },
      { text: 'Motivo', value: 'motivo' },
      { text: 'Anterior', value: 'teacher_anterior' },
      { text: 'Nuevo', value: 'teacher_nuevo' },
      { text: 'Situación', value: 'situacion' },
    ],
    headersSinTeacher: [
      { text: 'Sucursal', value: 'plantel' },
      { text: 'Grupo', value: 'grupo' },
      { text: 'Semana', value: 'semana' },
      { text: 'Bloque', value: 'bloque' },
    ],
  }),
  computed: {
    interno: {
      get() { return this.value },
      set(v) { this.$emit('input', v) },
    },
    idCiclo() {
      return this.ciclo && (this.ciclo.id_ciclo || this.ciclo)
    },
    modoDetalle() {
      return !!this.cardActiva
    },
    tituloCardActiva() {
      if (this.cardActiva === 'inbi') return 'INBI'
      if (this.cardActiva === 'fast') return 'FAST'
      if (this.cardActiva === 'ambas') return 'Ambas escuelas'
      return ''
    },
    headersActivos() {
      return this.modoDetalle ? this.headersDetalle : this.headersGeneral
    },
    /** Filtro numérico según tarjeta o select en modo general */
    escuelaFiltroTabla() {
      if (this.cardActiva === 'inbi') return 1
      if (this.cardActiva === 'fast') return 2
      if (this.cardActiva === 'ambas') return 0
      return Number(this.escuela) || 0
    },
    escuelaFiltroPayload() {
      return this.escuelaFiltroTabla
    },
    filas() {
      const all = (this.resumen && this.resumen.planteles) || []
      const esc = this.escuelaFiltroTabla
      if (esc === 1 || esc === 2) {
        return all.filter((r) => Number(r.escuela) === esc)
      }
      return all
    },
    /** Suma de la tabla visible (general o detalle). % recalculado sobre totales. */
    totales() {
      const rows = this.filas || []
      const sum = (key) => rows.reduce((a, r) => a + (Number(r[key]) || 0), 0)
      const total_clases = sum('total_clases')
      const total_cambios = sum('total_cambios')
      const cambios_permiso = sum('cambios_permiso')
      const cambios_falta = sum('cambios_falta')
      const pct = (a, b) => {
        if (!b) return 0
        return Math.round((a / b) * 10000) / 100
      }
      return {
        total_clases,
        total_cambios,
        cambios_permiso,
        cambios_falta,
        cambios_lunes: sum('cambios_lunes'),
        cambios_martes: sum('cambios_martes'),
        cambios_miercoles: sum('cambios_miercoles'),
        cambios_jueves: sum('cambios_jueves'),
        cambios_viernes: sum('cambios_viernes'),
        porcentaje_cambios: pct(total_cambios, total_clases),
        porcentaje_permiso_falta: pct(cambios_permiso + cambios_falta, total_clases),
      }
    },
    cardsGlobales() {
      const g = (this.resumen && this.resumen.globales) || {}
      const mk = (key, title, block) => ({
        key,
        title,
        clases: (block && block.total_clases) || 0,
        cambios: (block && block.total_cambios) || 0,
        pct: (block && block.porcentaje_cambios) || 0,
        pctPF: (block && block.porcentaje_permiso_falta) || 0,
      })
      return [
        mk('inbi', 'INBI', g.inbi),
        mk('fast', 'FAST', g.fast),
        mk('ambas', 'Ambas escuelas', g.ambas),
      ]
    },
  },
  watch: {
    value(v) {
      if (v) {
        this.avisoTabla = ''
        this.cardActiva = null
        this.cargar()
      }
    },
    dialogCambios(v) {
      if (v) this.cargarCambios()
    },
  },
  methods: {
    cerrar() {
      this.interno = false
    },
    /**
     * Clic en tarjeta:
     * - activa → tabla en modo detalle (L-V, escuela, %) filtrada
     * - re-clic → deselecciona y vuelve a tabla general
     */
    toggleCard(key) {
      if (this.cardActiva === key) {
        this.cardActiva = null
      } else {
        this.cardActiva = key
      }
    },
    labelMotivo(m) {
      const map = {
        permiso_teacher: 'Permiso del teacher',
        falta_teacher: 'Falta del teacher',
        retorno_titular: 'Retorno de clases a titular',
        motivos_climaticos: 'Por motivos climáticos',
        error_sistema: 'Por error en sistema',
        renuncia: 'Renuncia',
        despido: 'Despido',
        defuncion: 'Defunción',
        teacher_training: 'Teacher en training',
        grupo_apoyo: 'Grupo de apoyo',
        quejas_alumnos: 'Quejas de alumnos',
        conflictivo: 'Conflictivo',
        falta_enfermedad: 'Falta por enfermedad',
        inasistencias_recurrentes: 'Inasistencias recurrentes',
        deja_de_contestar: 'Deja de contestar',
        temporal: 'Temporal',
        otro: 'Otro',
      }
      return map[m] || m
    },
    payloadBase() {
      const c = this.ciclo || {}
      return {
        id_ciclo: this.idCiclo,
        id_ciclo_relacionado: c.id_ciclo_relacionado || null,
        escuela: this.escuelaFiltroPayload,
        periodo: this.periodo,
      }
    },
    cargar() {
      if (!this.idCiclo) {
        this.avisoTabla = 'Selecciona un ciclo en Roles Clases antes de consultar el KPI.'
        return
      }
      this.cargando = true
      this.avisoTabla = ''
      this.$http
        .post('rol.kpi.resumen', {
          ...this.payloadBase(),
          escuela: 0,
        })
        .then((res) => {
          this.resumen = res.data
        })
        .catch((e) => {
          const msg = (e.response && e.response.data && e.response.data.message) || e.message
          this.avisoTabla = msg
          this.resumen = null
        })
        .finally(() => {
          this.cargando = false
        })
    },
    cargarCambios() {
      this.cargandoCambios = true
      this.$http
        .post('rol.kpi.cambios', this.payloadBase())
        .then((res) => {
          this.cambios = res.data || []
        })
        .catch((e) => {
          const msg = (e.response && e.response.data && e.response.data.message) || e.message
          this.$emit('error', msg)
        })
        .finally(() => {
          this.cargandoCambios = false
        })
    },
    abrirSinTeacher() {
      this.dialogSinTeacher = true
      this.cargandoSinTeacher = true
      this.$http
        .post('rol.kpi.sin.teacher', this.payloadBase())
        .then((res) => {
          this.sinTeacher = res.data || []
        })
        .catch((e) => {
          const msg = (e.response && e.response.data && e.response.data.message) || e.message
          this.$emit('error', msg)
        })
        .finally(() => {
          this.cargandoSinTeacher = false
        })
    },
    guardarSituacion(item) {
      if (!item || !item.id) return
      this.$http
        .put('rol.kpi.cambio.situacion/' + item.id, { situacion: item.situacion })
        .then(() => {
          this.$emit('ok', 'Situación guardada')
        })
        .catch((e) => {
          const msg = (e.response && e.response.data && e.response.data.message) || e.message
          this.$emit('error', msg)
        })
    },
    exportarExcel() {
      let data
      if (this.modoDetalle) {
        data = this.filas.map((r) => ({
          Sucursal: r.plantel,
          Escuela: r.escuela_nombre || (Number(r.escuela) === 2 ? 'FAST' : 'INBI'),
          Clases: r.total_clases,
          Lunes: r.cambios_lunes,
          Martes: r.cambios_martes,
          Miercoles: r.cambios_miercoles,
          Jueves: r.cambios_jueves,
          Viernes: r.cambios_viernes,
          Total_cambios: r.total_cambios,
          Porcentaje_cambios: r.porcentaje_cambios,
        }))
      } else {
        data = this.filas.map((r) => ({
          Sucursal: r.plantel,
          Escuela: Number(r.escuela) === 2 ? 'FAST' : 'INBI',
          Clases: r.total_clases,
          Cambios: r.total_cambios,
          Porcentaje_cambios: r.porcentaje_cambios,
          Permiso: r.cambios_permiso,
          Falta: r.cambios_falta,
          Porcentaje_permiso_falta: r.porcentaje_permiso_falta,
        }))
      }
      const ws = XLSX.utils.json_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'KPI Roles')
      XLSX.writeFile(wb, 'kpi_roles_clases.xlsx')
    },
  },
}
</script>

<style scoped>
.card-kpi {
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.card-kpi:hover {
  border-color: #9e9e9e !important;
}
.card-kpi--activa {
  border-color: #3f51b5 !important;
  box-shadow: 0 0 0 2px rgba(63, 81, 181, 0.2);
  background: #f5f7ff;
}
.tabla-kpi-totales ::v-deep tbody tr.fila-totales {
  background: #eeeeee;
  border-top: 2px solid #9e9e9e;
}
.tabla-kpi-totales ::v-deep tbody tr.fila-totales td {
  font-size: 0.875rem;
  white-space: nowrap;
}
</style>
